import makeRequest from 'utils/makeRequest'
import { ENDPOINTS } from 'config/apiEndpoints'
import ISupportSocialsResponse from 'models/Support/ISupportSocials'
import { ISupportMutation } from 'models/Support/ISupport'

export const supportService = {
  getSupportSocials: async (): Promise<ISupportSocialsResponse> => {
    try {
      const response: ISupportSocialsResponse = await makeRequest(
        'GET',
        ENDPOINTS.Support.GetSupportSocials
      )

      return response
    } catch (error) {
      throw new Error(`Get support socials data failed: ${error}`)
    }
  },
  sendSupportMessage: async (supportInfo: ISupportMutation): Promise<any> => {
    try {
      const response: any = await makeRequest(
        'POST',
        ENDPOINTS.Support.Post,
        supportInfo
      )

      return response
    } catch (error) {
      console.error(error)
      throw new Error('Send support message failed')
    }
  },
}
